import React, { useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { UploadSimple, Copy } from "@phosphor-icons/react";

export default function Media() {
  const fileRef = useRef(null);
  const [uploads, setUploads] = useState([]);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const fd = new FormData();
    fd.append("file", f);
    try {
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const full = `${process.env.REACT_APP_BACKEND_URL}${r.data.url}`;
      setUploads((u) => [{ ...r.data, full, name: f.name }, ...u]);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    }
  };

  const copy = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("URL copied");
  };

  return (
    <div data-testid="admin-media" className="p-8 md:p-10">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display font-black text-3xl md:text-4xl">Media uploads</h1>
          <p className="mt-2 text-neutral-600">Upload images and copy their public URL to use anywhere.</p>
        </div>
        <input type="file" ref={fileRef} accept="image/*" className="hidden" onChange={upload} data-testid="media-input" />
        <button onClick={() => fileRef.current?.click()} data-testid="media-upload" className="btn-brand text-sm py-2.5 px-4">
          <UploadSimple size={14} weight="bold" /> Upload image
        </button>
      </div>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {uploads.map((u) => (
          <div key={u.id} className="bg-white border border-[color:var(--line)] p-3">
            <img src={u.full} alt={u.name} className="w-full aspect-video object-cover border border-[color:var(--line)]" />
            <div className="mt-3 flex items-center justify-between gap-2">
              <div className="text-xs truncate flex-1" title={u.name}>{u.name}</div>
              <button onClick={() => copy(u.full)} className="border border-[color:var(--line)] p-2 hover:border-black">
                <Copy size={14} />
              </button>
            </div>
          </div>
        ))}
        {uploads.length === 0 && <div className="col-span-full text-neutral-500 text-sm">No uploads this session — files are stored server-side.</div>}
      </div>
    </div>
  );
}
